@if (loading) {
  <span class="loading-spinner" role="status" aria-label="Signaturprüfung läuft"></span>
} @else if (validation; as v) {
  <span class="validation-wrapper">
    <span class="validation-icon"
          [class.valid]="v.status === 'valid'"
          [class.invalid]="v.status !== 'valid'"
          tabindex="0"
          role="img"
          [attr.aria-label]="statusLabel">
      <svg viewBox="2 2 20 20" fill="currentColor" aria-hidden="true"><path [attr.d]="iconPath"/></svg>
    </span>
    <div class="validation-tooltip" role="tooltip">
      <strong>{{statusLabel}}</strong>
      @for (sig of v.signatures; track sig.name) {
        <div class="signature-detail">
          <div class="signature-name">{{sig.name}}</div>
          <ul>
            @for (check of sig.checks; track check.type) {
              <li>{{checkTypeLabel(check.type)}}: {{checkStatusLabel(check.status)}}</li>
            }
          </ul>
        </div>
      }
    </div>
  </span>
} @else {
  <span class="validation-wrapper">
    <span class="validation-icon pending"
          tabindex="0"
          role="img"
          aria-label="Signaturprüfung nach Upload">
      <svg viewBox="2 2 20 20" fill="currentColor" aria-hidden="true"><path [attr.d]="pendingIconPath"/></svg>
    </span>
    <div class="validation-tooltip" role="tooltip">
      Dieses Dokument wird nach dem Upload auf eine gültige QES-Signatur geprüft.
    </div>
  </span>
}
